import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { z } from 'zod'
import { QUERIES } from '@/constants/queries'
import { ROLES } from '@/constants/roles'
import { ROUTES } from '@/constants/routes'
import { signIn } from '@/services/auth/sign-in'
import { useAuthStore } from '@/store/auth-store'

export const signInSchema = z.object({
  email: z.string().email('Peencha um email válido'),
  password: z.string().nonempty('Preencha a senha')
})

export type SignInType = z.infer<typeof signInSchema>

export const useSignIn = () => {
  const navigate = useNavigate()
  const { setSession } = useAuthStore()
  const location = useLocation()

  const {
    register,
    handleSubmit: formSubmit,
    control,
    formState: { errors }
  } = useForm({
    resolver: zodResolver(signInSchema),
    defaultValues: {
      email: '',
      password: ''
    }
  })

  const handleSubmit = formSubmit((data: SignInType) => {
    mutate(data)
  })

  const { mutate, isPending, data } = useMutation({
    mutationKey: [QUERIES.SIGN_IN],
    mutationFn: (data: SignInType) => signIn(data),
    onSuccess: (data) => {
      if (data.data) {
        data = data.data
        setSession(
          data.accessToken,
          data.refreshToken,
          data.userName,
          data.role,
          data.id
        )
        let navPath = `/${ROUTES.MANAGER_PANEL.route}`
        if (data.role === ROLES.MANAGER.id) {
          if (location.pathname !== `/${ROUTES.SIGN_IN.route}`) {
            navPath = location.pathname
          }

          navigate(navPath)
        }
      }
    }
  })

  return {
    state: {
      isPending,
      errors,
      data,
      control
    },
    actions: {
      handleSubmit,
      register
    }
  }
}
